import { Marker, marker, DivIcon, divIcon } from 'leaflet'

export function CustomMarker(
	coords: L.LatLngExpression,
	properties: any
): Marker {
	const { Name, Status, Url, DisplayStatus } = properties

	const markerIcon = Status != null ? Status.toLowerCase() : 'planning'

	const customIcon: DivIcon = divIcon({
		className: 'custom-marker',
		html: `<div class="icon-container uk-position-absolute uk-flex uk-flex-middle uk-flex-center"><span class='uk-icon' uk-icon="${markerIcon}"></span></div>`,
		iconSize: [28, 28],
		iconAnchor: [15, 32],
		popupAnchor: [0, 6],
	})

	let content = `<span aria-label="Kartmarkør" title="Kartmarkør" class='uk-icon' uk-icon="${markerIcon}"></span> ${
		DisplayStatus != null ? DisplayStatus : Status == null ? '' : Status
	}`
	if (Url != null) {
		content += `<p><a href="${Url}">${Name}<span uk-icon="icon:nv-arrow; ratio: .65" class="uk-margin-xsmall-left"></span></a></p>`
	} else {
		content += `<p>${Name}</p>`
	}

	const newMarker = marker(coords, { icon: customIcon }).bindPopup(
		'<div class="popup-inner">' + content + '</div>',
		{
			minWidth: 220,
			maxWidth: 220,
			className: 'custom-popup',
		}
	)

	newMarker.on('popupopen', (e) => {
		// Hide icon when popup opens
		if (e.target) {
			const element = (e.target as any).getElement()
			if (element) {
				element.style.display = 'none'
			}
		}
		const closeButton = document.querySelector('.leaflet-popup-close-button')
		if (closeButton) {
			closeButton.innerHTML =
				'<span aria-label="Fjern" title="Fjern" uk-icon="icon: nv-minus;"></span>'
		}
	})

	newMarker.on('popupclose', (e) => {
		// Show icon when popup closes
		if (e.target) {
			const element = (e.target as any).getElement()
			if (element) {
				element.style.display = 'block'
			}
		}
	})

	return newMarker
}
